import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ViewService } from '../../../../services/view.service';

@Component({
  selector: 'sub-navigation-item',
  imports: [RouterModule, MatIcon],
  templateUrl: './sub-navigation-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sub-navigation-item.component.scss',
})
export class SubNavigationItemComponent<T extends string> {
  @Input() path: string;
  /* For mobile navigation */
  @Input() icon: string;

  @HostBinding('class.active') get isActive() {
    return this.viewService.currentView() === this.path;
  }

  constructor(public viewService: ViewService<T>) {}
}
